import { applyMiddleware, compose, createStore } from 'redux';
import createReducers from '../reducers';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import analytics from './analyticsMiddleware';
import redirectTo from './redirectMiddleware';
import { persistStore } from 'redux-persist';
import { routerMiddleware } from 'connected-react-router';
import { fetchMiddleware } from '../utils/fetch';

export default (state = {}, history) => {
  const middlwareList = [
    fetchMiddleware,
    thunk,
    promise,
    analytics,
    redirectTo,
    history ? routerMiddleware(history) : undefined
  ].filter(Boolean);
  const middleware = applyMiddleware(...middlwareList);

  const createStoreWithMiddleware = compose(
    middleware,
    typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f
  );
  const store = createStoreWithMiddleware(createStore)(createReducers(history), state);
  store.presistor = persistStore(store);
  return store;
};
